const autocompletionRequestBuilder = (
  autocompletionRequest: any,
  input: string,
  sessionToken?: google.maps.places.AutocompleteSessionToken
): any => {
  const { bounds, location, ...rest } = autocompletionRequest;

  const res: any = {
    input,
    ...rest
  };

  if (sessionToken) {
    res.sessionToken = sessionToken;
  }

  if (bounds) {
    res.bounds = new google.maps.LatLngBounds(...bounds);
  }

  if (location) {
    res.location = new google.maps.LatLng(location);
  }

  return res;
};

export default autocompletionRequestBuilder;
